export default __webpack_public_path__ + "static/media/logo.97d28a9c.webp";